module.exports = __webpack_public_path__ + "static/media/confirmation.06785b35.svg";